module.exports = __webpack_public_path__ + "static/media/31JFA2.9ca02e92.jpg";